module.exports = __webpack_public_path__ + "static/media/poster_4.a275feb6.png";